<div
  class="filter-panel-container"
  [class.filter-panel-container--is-edit-mode]="isEditMode"
  [class.filter-panel-container--invalid]="!isFilterPanelValid"
>
  <ng-content select=".before-close"></ng-content>
  <!--Close edit mode-->
  <button
    class="tui-space_right-2"
    *ngIf="isEditMode"
    [disabled]="!isFilterPanelValid"
    (click.stop)="closeEditMode()"
    tuiButton
    appearance="primary"
    size="m"
  >
    OK
  </button>
  <!--Close edit mode-->
  <ng-content select=".after-close"></ng-content>
</div>
